import PropTypes from 'prop-types';
import React from 'react';
import CardHeader from '../shared/CardHeader';
import styles from './DomoApp.css?module';
import {FluidRatio} from 'components/Ratio';
import DomoAppPreview from './DomoAppPreview';

class DomoApp extends React.Component {
  render() {
    const {card, pageId} = this.props;

    return (
      <div className={styles.content}>
        <CardHeader card={card} />
        <FluidRatio x={2} y={1}>
          {(width, height, hasComputed) =>
            hasComputed ? (
              <DomoAppPreview
                domoappId={card.domoapp.id}
                pageId={pageId}
                cardId={card.urn}
                width={width}
                height={height}
                isResizing={!hasComputed}
              />
            ) : null
          }
        </FluidRatio>
      </div>
    );
  }
}

DomoApp.propTypes = {
  card: PropTypes.object.isRequired,
};

export default DomoApp;
